// Oddělovač sekcí uvnitř dropdownu — čára (hairline) nebo jen mezera, dle `variant`.
// `sep` = typ z dat (`space`/`line`); `line` je výraznější varianta.

import { cn } from '@/shared/lib/utils';

import type { MenuSepStyle } from './menuTypes';

export interface SectionSeparatorProps {
  readonly sep: 'space' | 'line';
  readonly variant: MenuSepStyle;
}

export function SectionSeparator({ sep, variant }: SectionSeparatorProps) {
  if (variant === 'lines') {
    return (
      <div
        className={cn(
          'my-phx-2_5 mx-1.5 h-px',
          sep === 'line' ? 'bg-phx-border-2' : 'bg-phx-border'
        )}
      />
    );
  }
  return <div className={sep === 'line' ? 'h-[9px]' : 'h-2'} />;
}
